import Button from '@shared/components/Button/Button';

import { ReactComponent as Mail } from 'assets/icons/Mail.svg';
import { ReactComponent as X } from 'assets/icons/X.svg';
import { IconType } from 'utils/types';

interface AddedParticipantProps {
  children: string;
  icon?: IconType;
  onRemove?: (participantEmail: string) => void;
}

const AddedParticipant = ({ children, icon: Icon = Mail, onRemove }: AddedParticipantProps) => (
  <div className="flex justify-between items-center py-1 px-4 bg-gray-10 rounded-2xl min-h-[40px]">
    <div className="flex gap-2 items-center w-full truncate">
      <Icon className="stroke-gray-80 h-4 w-4 shrink-0 stroke-1.5" />
      <span className="text-black text-size-sm truncate">{children}</span>
    </div>
    {onRemove && (
      <Button
        variant="buttonIconGhost"
        size="neutral"
        className="!rounded-xl p-1 ml-2"
        onClick={() => onRemove(children)}
      >
        <X className="stroke-gray-50 h-6 w-6 shrink-0 stroke-1.5" />
      </Button>
    )}
  </div>
);

export default AddedParticipant;
